export default {
	TEACHER: 'Teacher',
	INSTRUCTIONAL_COACH: 'Instructional Coach',
	LIBRARY_MEDIA_SPECIALIST: 'Library Media Specialist',
	PURCHASING_SECRETARY: 'Purchasing Secretary',
	SCHOOL_ADMINISTRATOR: 'School Administrator',
	DISTRICT_ADMINISTRATOR: 'District Administrator',
	PARENT_HOMESCHOOL: 'Parent/Homeschool',
	OTHER_SCHOOL_EMPLOYEE: 'Other School Employee',
	STUDENT: 'Student',
}
